import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { showSuccessToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import type { CrmEnrichmentJob } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

import { useHsEnrichmentJobCache } from "../hooks/useHsEnrichmentJobCache";
import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

export default function useHsEnrichmentJobEditMutation() {
    const { updateExistingJobInCache } = useHsEnrichmentJobCache();
    const dispatch = useDispatch();

    return useMutation<CrmEnrichmentJob, unknown, CrmEnrichmentJob>({
        mutationFn: async (dto: CrmEnrichmentJob) => {
            await hubspotEnrichmentAPIService.updateJob(dto);
            return dto;
        },
        onSuccess: (data: CrmEnrichmentJob) => {
            updateExistingJobInCache(data);
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text: translate("si.crm-enrichment.hs.job-editor.success.toast"),
                    }),
                ),
            );
        },
    });
}
